import React from "react"
import { Post } from "posts/posts.types"
import { ReactFC } from "types"
import styled from "styled-components"


export interface EventTitleProps {
  post: Post
}

const TitleWrapper = styled.div`
`

const Title = styled.h1`
`

export const EventTitle: ReactFC<EventTitleProps> = ({ post }) => {
  if (!post?.event) {
    return null
  }

  return (
    <TitleWrapper dir="auto">
      <Title>
        {post.title}
      </Title>
    </TitleWrapper>
  )
}

